module.exports = __webpack_public_path__ + "img/m18.de2c8bd3.jpg";